import { Observable } from 'rxjs';
import { Language } from '../language';
import { ITranslationsApiResponse } from '../translation.types';

/**
 * TranslationRepository — DDD repository contract for translation sources.
 *
 * Two interchangeable implementations live in `infrastructure/`:
 *   · MockTranslationRepository  (local dictionary — DEFAULT, runs offline)
 *   · HttpTranslationRepository  (real API behind the same interface)
 *
 * Swap which one is bound in `i18n.providers.ts` (or via I18N_CONFIG.useMock).
 * The application layer (TranslationsService) depends ONLY on this abstraction.
 */
export abstract class TranslationRepository {
  abstract getTranslations(lang: Language): Observable<ITranslationsApiResponse>;
}
